module.exports = __webpack_public_path__ + "static/media/overhead-spend.f69487d6.svg";